<template>
  <button
    v-ripple
    :class="{
      'tw-text-white tw-bg-ci-green hover:tw-bg-ci-green/90 focus:tw-ring-ci-green disabled:tw-bg-ci-green/75':
        theme === 'primary',
      'tw-text-white tw-bg-ci-gray-500 hover:tw-bg-ci-gray-500/90 focus:tw-ring-ci-gray-500 disabled:tw-bg-ci-gray-500/75':
        theme === 'secondary',
      'tw-text-white tw-bg-rose-500 hover:tw-bg-rose-500/90 focus:tw-ring-rose-100 disabled:tw-bg-rose-500/75':
        theme === 'danger',
      'tw-text-black tw-bg-white hover:tw-bg-white/90 focus:tw-ring-white disabled:tw-bg-white/75':
        theme === 'light',
      'tw-text-black hover:tw-bg-gray-200/90 focus:tw-ring-gray-200':
        theme === 'tertiary',
    }"
    :disabled="disabled || loading"
    class="tw-min-h-[40px] tw-transition-all tw-font-semibold tw-text-base tw-relative tw-w-full focus:tw-ring-4 focus:tw-outline-none focus:tw-ring-offset-2 focus:tw-ring-opacity-30 lg:tw-w-auto tw-px-5 tw-py-2 tw-rounded-full disabled:tw-cursor-not-allowed tw-outline-0"
    data-test-buttons-primary-button
    v-bind="$attrs"
    v-on="$listeners">
    <span
      :class="{
        'tw-opacity-0': loading && !prependIcon && !appendIcon,
        'max-lg:tw-opacity-0': loading,
      }"
      class="tw-transition-opacity tw-duration-200 tw-leading-snug tw-flex tw-justify-center tw-items-center tw-font-semibold">
      <v-icon
        v-if="prependIcon"
        :class="{ 'tw-opacity-0': loading }"
        class="-tw-ml-1 tw-mr-2.5 tw-text-inherit"
        size="22px">
        {{ prependIcon }}
      </v-icon>
      <slot></slot>
      <v-icon
        v-if="appendIcon"
        :class="{ 'tw-opacity-0': loading }"
        class="-tw-mr-1 tw-ml-2.5 tw-text-inherit"
        size="22px">
        {{ appendIcon }}
      </v-icon>
    </span>
    <transition name="fade">
      <span
        v-if="loading"
        :class="{
          'tw-inset-0': !prependIcon && !appendIcon,
          'tw-left-0 max-lg:tw-right-0 lg:tw-left-3.5 tw-top-2': prependIcon,
          'max-lg:tw-left-0 tw-right-0 lg:tw-right-3.5 tw-top-2': appendIcon,
        }"
        class="tw-absolute tw-flex tw-justify-center tw-items-center">
        <v-icon class="tw-animate-spin tw-text-inherit">mdi-loading</v-icon>
      </span>
    </transition>
  </button>
</template>

<script>
export default {
  name: 'Button',
  inheritAttrs: false,
  props: {
    theme: {
      type: String,
      default: 'primary',
      enum: ['primary', 'secondary', 'light', 'danger', 'tertiary'],
    },
    prependIcon: {
      type: String,
    },
    appendIcon: {
      type: String,
    },
    loading: {
      type: Boolean,
      default: false,
    },
    disabled: {
      type: Boolean,
      default: false,
    },
  },
}
</script>

<style>
.fade-enter-active {
  transition: transform 0.2s ease-in-out;
}

.fade-enter-from {
  transform: scale(0.8);
}

.fade-enter-to {
  transform: scale(1);
}
</style>
